<script>
  import { layoutMethods, customerMethods, customerListComputed, peddlrWalletKycMethods} from "@/state/helpers";
  import profileHeader from "@/views/pages/profileInformation/profileHeader.vue";
  import profileWallet from "@/views/pages/profileInformation/profileWallet.vue";
  import profileSocMed from "@/views/pages/profileInformation/profileSocMed.vue";
  import profileInformation from "@/views/pages/profileInformation/profileInformation.vue";
  import profileKycDetails from "@/views/pages/profileInformation/profileKycDetails.vue";
  import profileBusinessData from "@/views/pages/profileInformation/profileBusinessData.vue";
  import profileMdrSettings from '@/views/pages/profileInformation/profileMdrSettings.vue';

  /**
   * Profile Information component
   */
  export default {
    page: {
      title: "Profile Information"
    },
    components: {
      profileHeader,
      profileWallet,
      profileSocMed,
      profileInformation,
      profileKycDetails,
      profileBusinessData,
      profileMdrSettings
    },
    computed: {
      ...customerListComputed
    },
    data() {
      return {
        title     : "Profile Information",
        userId    : 0,
        businessId: 0,
        infoType  : null,
      };
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      ...peddlrWalletKycMethods,
      reload(){
        this.getBusinessDetailsv2({id: this.businessId});
      }
    },
    async mounted(){
      this.userId = this.$route.params.id
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Merchant List', to: { name: 'Subscriber'} },
          { text: 'Merchant Details', to: { name: 'Profile Information'} }
        ]
      });
      
      //this will initialize businessDetails
      await this.getBusinessDetailsv2({id: this.businessId}).then(async()=>{
        await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
      });
      // console.log(":: this.businessDetails ::",JSON.stringify(this.businessDetails));
      // await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
      // console.log(":: this.userKycStatus ::",JSON.stringify(this.userKycStatus));
    }
  }
    
</script>


<template>
  <div class="row"><!-- outer div-->
    <button style="display: none;" @click="reload">reload</button>
    <div class="col-xl-3">
      <profile-header/>
      <profile-wallet/>
      <profile-mdr-settings/>
      <profile-soc-med/>
    </div>
    <div class="col-xl-9">
      <!-- v-bind:mainData="{sid: userId, bid: businessId, infoType: infoType}" -->
      <profile-information/>
      <profile-kyc-details/>
      <profile-business-data/>
    </div>
  </div> <!-- end of outer div-->
</template>


<style>
</style>